import { BaseModel, Resource, Form, Entry } from '@ngx-resource-toolkit/core';
import { environment } from '../../environments/environment';
import { LeaResource } from '../shared/resource/lea.resource';

@Resource({
    modes: {
        'default': {
            url: environment.proxyUrl + '/authentification',
            methods: LeaResource.methods,
        }
    }
})
@Form({
    'login': {}
})
export class LoginModel extends BaseModel {

    @Entry({
        'login': {}
    })
    username: string;


    @Entry({
        'login': {}
    })
    password: string;

    constructor(data?) {
        super();
        if (!data) {
            data = {};
        }
        this.username = data.username;
        this.password = data.password;
    }
}



// WEBPACK FOOTER //
// /builds/eveasoft/lea/lea-front/src/app/login/login.model.ts